// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import {combineReducers, Reducer} from '@reduxjs/toolkit';
import {enableBatching} from 'redux-batched-actions';

export function createReducer<S>(...reducerSets: any[]): Reducer<S> {
    // Merge each dictionary of reducers into a single combined reducer
    let reducer = combineReducers<S>(
        reducerSets.reduce((fullSet, reducerSet) => {
            return {...fullSet, ...reducerSet};
        }, {}));

    // eslint-disable-next-line no-process-env
    if (process.env.NODE_ENV === 'test') {
        reducer = enableBatching(reducer);
    }

    return reducer as Reducer<S>;
}
